













































































































































import { defineComponent, onMounted, PropType } from '~/utils/nuxt3-migration'
import { ButtonVariant } from '~/models/app/button'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import CInternationalTelephoneInput from '~/components/shared/configurable/form/input/CInternationalTelephoneInput.vue'
import COverlay from '~/components/shared/configurable/overlay/COverlay.vue'
import CRecaptchaText from '~/components/shared/configurable/CRecaptchaText.vue'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import CInputGroup from '~/components/shared/configurable/form/input/CInputGroup.vue'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import CInputGroupText from '~/components/shared/configurable/form/input/CInputGroupText.vue'
import { ciPaperPlane } from '~/icons/source/solid/paper-plane'
import { ciQuestionCircle } from '~/icons/source/regular/question-circle'
import { useContactForm } from '~/compositions/form/contact'

export default defineComponent({
  components: {
    COverlay,
    CFormError,
    CInternationalTelephoneInput,
    CRecaptchaText,
    CFormGroup,
    CTextArea,
    CInputGroup,
    CInputGroupText
  },
  props: {
    formUrl: {
      type: String,
      required: true
    },
    recaptchaToken: {
      type: String,
      default: 'contact_form'
    },
    successMessage: {
      type: String
    },
    btnVariant: {
      type: String as PropType<ButtonVariant>,
      default: 'primary'
    },
    extraParams: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },
  setup(props, { emit }) {
    const {
      values,
      schema,
      errors,
      isReady,
      isLoading,
      isSuccess,
      threadToGo,
      isManager,
      managerOptions,
      hasRecipients,
      recipientsOptions,
      recaptchaWidgetContainerId,
      recaptchaFallbackWidgetLoaded,
      senderChange,
      submitContactForm
    } = useContactForm(props)

    onMounted(() => emit('mounted'))

    return {
      ciPaperPlane,
      ciQuestionCircle,
      values,
      schema,
      errors,
      isReady,
      isLoading,
      isSuccess,
      threadToGo,
      isManager,
      managerOptions,
      hasRecipients,
      recipientsOptions,
      recaptchaWidgetContainerId,
      recaptchaFallbackWidgetLoaded,
      senderChange,
      submitContactForm
    }
  }
})
